import { render, staticRenderFns } from "./recomendDoctorRes.vue?vue&type=template&id=337478b5&scoped=true&"
import script from "./recomendDoctorRes.vue?vue&type=script&lang=js&"
export * from "./recomendDoctorRes.vue?vue&type=script&lang=js&"
import style0 from "./recomendDoctorRes.vue?vue&type=style&index=0&id=337478b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337478b5",
  null
  
)

export default component.exports